<div class="nav-items">
  <div>
    @for (element of headerElements; track element) {
      @if ((!isOnHome() && element.elemId === 'home') || isOnHome()) {
        <a (click)="onItemClick($event, element.elemId)" [className]="'nav-' + element.elemId" [matTooltip]="element.displayName | translate" matTooltipPosition="below">
          <div class="icon-nav">
            @switch (element.elemId) {
              @case ('home') {
                <span class="header-icon icon-home"></span>
              }
              @case ('help-topics') {
                <span class="header-icon icon-circle-information"></span>
              }
              @case ('important-links') {
                <span class="header-icon icon-link"></span>
              }
              @case ('faq') {
                <span class="header-icon icon-circle-help"></span>
              }
            }
          </div>
          <div class="text-nav">
            {{ element.displayName | translate }}
          </div>
        </a>
      }
    }
    @if (isOnHome()) {
      <span class="slider" [style.width]="sliderWidth" [style.left]="sliderOffset"></span>
    }
  </div>
</div>
